// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI Elements
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import AddBoxIcon from '@material-ui/icons/AddBox';

// Import Components
import Action from '../Action/Action';
import Clipboard from '../Clipboard/Clipboard';

const useStyles = makeStyles((theme) => ({
    header: {
        justifyContent: 'space-between',
        color: 'white',
        backgroundColor: 'var(--black-pearl)',
        fontSize: '12px',
        padding: '8px',
        alignItems: 'center',
        display: 'flex'
    }
}));

function MiddleModal({
    variables,
    setOpenVariable,
    value,
    selectedVariable,
    setConfigureModal,
    configureModal,
    variableRender,
    saveConfiguration
}) {
    const { t } = useTranslation();
    const theme = useTheme();

    const [loading, setLoading] = useState(true);
    const [actions, setActions] = useState([]);

    const fullWidth = useMediaQuery(theme.breakpoints.up('lg'));
    const label = 'CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.ADVANCED-ASSIGN.';

    useEffect(() => {
        setTimeout(() => {
            setActions(JSON.parse(JSON.stringify(value.manipulations)));
            setLoading(false);
        }, 1000)
    }, [])

    const addAction = () => {
        let actionData = [...actions];
        actionData.push({});
        setActions(actionData)
    }

    const classes = useStyles();

    return (
        loading ? (
            <Dialog open={true} maxWidth={'sm'}><DialogActions style={{ padding: '30px' }}><CircularProgress /></DialogActions></Dialog >
        ) : (
            < Dialog open={configureModal.isOpen} fullWidth={fullWidth} maxWidth={'lg'}>

                <DialogTitle id="responsive-dialog-title">
                    <div>
                        <b style={{ borderBottom: '1px solid #bec0ca' }}>{t(label + 'CONFIGURE-DATA')}</b>
                    </div>

                </DialogTitle>
                <DialogContent style={{ minHeight: '500px', maxHeight: '500px', padding: '0% 3% 3% 3%' }} >
                    <Grid container >
                        <Grid item xs={6}>
                            <div style={{ fontSize: '13px', color: '#8C90A2', fontWeight: 700, marginBottom: '5px' }}>
                                {t(label + 'CONFIGURE-MODAL-DESCRIPTION')}
                            </div>
                            <Card style={{ border: "1px solid var(--black-pearl)", marginBottom: '2%' }}>
                                <CardHeader className={classes.header} titleTypographyProps={{ variant: '' }} title={value.keyPath}
                                    action={
                                        <IconButton style={{ color: '#fcfcfc', marginTop: '8px' }} onClick={addAction}>
                                            <AddBoxIcon style={{ marginLeft: '2%' }} />
                                        </IconButton>
                                    }
                                />
                                <CardContent style={{ backgroundColor: '#fcfcfc' }}>
                                    {
                                        actions.map((action, index) => <Action valueType={value.type} outputVariable={value.set} actions={actions} setActions={setActions} index={index}
                                            variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} />)
                                    }
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={1}>
                            <Divider style={{ marginLeft: '50%' }} orientation={'vertical'} />
                        </Grid>
                        <Grid item xs={5} >
                            <Clipboard selectedVariable={selectedVariable} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'space-between' }}>
                    <Button
                        onClick={() => setConfigureModal({ isOpen: false, index: 0 })}
                        variant="outlined"
                        style={{ backgroundColor: "#BBBBBB", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
                        {t('CONTENT.MODAL.CANCEL')}
                    </Button>
                    <Button
                        onClick={() => saveConfiguration(actions, configureModal.index)}
                        variant="outlined"
                        style={{ backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
                        {t('CONTENT.MODAL.SAVE')}
                    </Button>
                </DialogActions>
            </Dialog >
        )
    )
}

export default MiddleModal;